import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Global } from '@services/core/Global';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ModelService {

    private http = inject(HttpClient);

    get(): Observable<any> {
        return this.http.get(Global.url + 'V1/vehicle-model-ref');
    }

    create(data: any): Observable<any> {
        return this.http.post(Global.url + 'V1/vehicle-model-ref', data);
    }

    update(id: any, data: any): Observable<any> {
        return this.http.put(Global.url + 'V1/vehicle-model-ref/' + id, data);
    }

    delete(id: any): Observable<any> {
        return this.http.delete(Global.url + 'V1/vehicle-model-ref/' + id);
    }
}
